/**
 * Resolves after the browser has painted the next frame. Await it before (and between chunks of)
 * long main-thread work so a loading state set just before actually shows, instead of the page
 * freezing on the previous frame.
 *
 * @returns {Promise<void>}
 */
export const waitForPaint = () =>
  new Promise((resolve) => {
    requestAnimationFrame(() => setTimeout(resolve, 0));
  });
